import React from 'react';
import { inject,observer } from 'mobx-react';
import * as mobx from 'mobx';
import { getAntd,getEcCom,getLabel } from '../../../util/convert';
import Content from './Content';

@inject('overTimeStore')
@observer
export default class Main extends React.Component{
    render(){
        const { WeaDialog } = getEcCom();
        const { visible } = this.props;
        return (
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@iy57rr`}
                visible={visible}
                loadCss={true}
                initLoadCss={true}
                title={getLabel(18818,'超时设置')}
                icon="icon-coms-workflow"
                iconBgcolor='#0079DE'
                maskClosable={false}
                onCancel={this.doCancel}
                style={{width:"550px", height:"520px"}}
            >
                <Content ecId={`${this && this.props && this.props.ecId || ''}_Content@0eq8o0`} {...this.props} />
            </WeaDialog>
        )
    }
    doCancel = () => {
        const { overTimeStore } = this.props;
        overTimeStore.closeEvent();
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/dialog/overtime-setting/index.js